declare global {
  interface Window {
    _satellite: { track: (analyticEvent: any) => void };
  }
}

export const triggerAnalyticsEvent = (analyticEvent: string) => {
  if (window._satellite) {
    window._satellite.track(analyticEvent);
  }
};
